<template lang="pug">
  label.to-click(
  style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; padding-right: 5px;"
    @dblclick="dblclick($event, item)"
  )
    input(type="checkbox", v-model="itemValue", :disabled="disabled")
    span.noselect &nbsp; {{ item.name || item[uniqueKey] }}
</template>

<script>
import { handlerUseStateVmodel } from '../mixins'

export default {
  mixins: [handlerUseStateVmodel(true)],
  props: {
    item: { required: true, type: Object },
    useState: { type: String },
    value: { type: Object },
    uniqueKey: { type: String },
    disabled: { type: Boolean, 'default': false },
    onChange: { type: Function }
  },
  computed: {
    itemValue: {
      get () {
        const allSelected = this.state.selected
        for (let i in allSelected) {
          let current = allSelected[i]
          if (this.item.id === current.id) {
            return true
          }
        }
        return false
      },
      set (newValue) {
        const allSelected = this.state.selected
        if (this.itemValue === true) {
          this.state = { selected: allSelected.filter(i => i.id !== this.item[this.uniqueKey]) }
        } else {
          this.state = { selected: [...allSelected, this.item] }
        }
        if (this.onChange) {
          this.onChange(this.item, this.itemValue === true)
        }
      }
    }
  },
  methods: {
    dblclick (e, item) {
      e.stopImmediatePropagation()
      this.$emit('dblclick', e, item)
    }
  }
} /* eslint-disable */ 
</script>

<style scoped>
  label { margin-left: 10px; }
</style>
